/* eslint-disable */
import React, { useState } from "react";

// Custom Components
import Table from "@Components/Table";
import Filter from "components/Filter";
import withSelect from "../withSelect";
import { URLS, ESTATE_FETCH_URL } from "configs/constants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";

let model = [
  { id: "group_id", label: "Code", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "company_name", label: "Company", type: "string" },
  { id: "zone_name", label: "Zone", type: "string" },
  { id: "region_name", label: "Region", type: "string" },
  { id: "estate_name", label: "Estate", type: "string" },
  { id: "status_label", label: "Status", type: "string" },
];
import * as Yup from "yup";
import { ZONE_FETCH_URL } from "configs/constants";
import { REGION_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";



const pageNumberDropdown = true;

const filterInitialValues = {
  code: "",
  name: "",
  estate: "",
  active: null,
};

const WorkerGroupList = () => {
  const [filterValues, setFilterValues] = useState({});
  const history = useHistory();
  const [disableZone, setDisableZone] = useState(true);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);

  const actions = [
    // {
    //     type: "view",
    //     title: "View",
    //     icon: <VisibilityIcon />,
    //     color: "secondary",
    //     onClick: (id) => history.push(`${history.location.pathname}/view-details/${id}`),
    //   },
    "edit"];
    const getCompanyValues = (e, setDisableZone) => {
      if (!e || e.length === 0) {
        setDisableZone(true);
      }
      else {
        setDisableZone(false);
      }
    
    };

    const getZoneValues = (e, setDisableRegion) => {
      if (!e || e.length === 0 || e.label == "N/A") {
        setDisableRegion(true);
      }
      else {
        setDisableRegion(false);
      }
    
    };
    const getRegionValues = (e, setDisableEstate) => {
      if (!e || e.length === 0) {
        setDisableEstate(true);
      }
      else {
        setDisableEstate(false);
      }
    
    };
  const filterFields = [
    {
      type: "input",
      label: "Code",
      name: "code",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,


    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      paginated: false,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      disabled:disableZone,
      optionsDependsOn: "company",
      isPaginationEnabled: false,
      isAllowablesEnabled: false,

    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: false,
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      disabled: disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",

    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: false,
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      disabled: disableEstate,
      optionsDependsOn: "region",

    },

    {
      type: "reactselect",
      name: "active",
      label: "Status",
      outerOptions: [
        { id: "1", name: "ACTIVE" },
        { id: "0", name: "INACTIVE" },
      ],
    },
  ];
  // const validationSchema = Yup.object({


  //   estate: Yup.string()
  //   .required("Estate is required")
  //   .typeError("Invalid Estate")
  //   .nullable(),


  // });
  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <div>
      {/* FIXME: 10953 - Filter hidden for now */}
      <div style={{ margin: '5px' }}>

        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
        // validationSchema={validationSchema}

        />
      </div>
      {filtersApplied ? (

        <Table
          proxyURL="worker-group/bo-list/"
          model={model}
          actions={actions}
          filterValues={filterValues}
          pageNumberDropdown={pageNumberDropdown}

          noFilter
        />
      ) : (
        <Table
          proxyURL={null}
          model={model}
          actions={actions}
          filterValues={filterValues}
          pageNumberDropdown={pageNumberDropdown}

          noFilter
        />
      )}

    </div>
  );
};

export default withSelect(WorkerGroupList, URLS.WORKER_GROUP_CUSTOM_FIELDS);
